import { render, staticRenderFns } from "./PricingCalculator.vue?vue&type=template&id=3bcf8354&scoped=true"
import script from "./PricingCalculator.vue?vue&type=script&lang=js"
export * from "./PricingCalculator.vue?vue&type=script&lang=js"
import style0 from "./PricingCalculator.vue?vue&type=style&index=0&id=3bcf8354&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcf8354",
  null
  
)

export default component.exports